import { useState } from "react";
import ScrollStack, { ScrollStackItem } from "./ScrollMapComponent/ScrollStack";
import InteractiveMap from "./ScrollMapComponent/InteractiveMap";
import { Box, Typography } from "@mui/material";
import GlobalReachVideo from "../assets/videos/dureWorldReach.mp4";

const GlobalReach = () => {
  const [mapBlurred, setMapBlurred] = useState(false);
  const [currentCountry, setCurrentCountry] = useState(null);

  const countryData = [
    {
      heading: "NIGERIA",
      body: "Nigeria, under the leadership of the Ministry of Health, is driving digital transformation through multi-program National Situation Rooms that unify data across HIV, TB, malaria, immunization, and outbreak response. Alongside this, a community-led monitoring system empowers citizens to provide bottom-up insights, creating a more integrated, resilient, and participatory health system that sets a benchmark for the region.",
      countryCode: "NGA",
    },
    {
      heading: "CENTRAL AFRICAN REPUBLIC",
      body: "Despite its fragility, the Central African Republic is driving one of the region’s most comprehensive digital transformation efforts, guided by the vision of the Minister of Health and other key ministries. By integrating digital health solutions with enabling infrastructure and capacity building, the country is setting a benchmark for resilience and innovation that can inspire neighboring nations.",
      countryCode: "CAF",
    },
    {
      heading: "SWITZERLAND",
      body: "Dure Technologie's Geneva hub serves as a global center for innovation and partnerships, hosting the Swiss Obesity Registry, the Global OneImpact platform for HIV and TB, and the Climate and Health Knowledge Hub. It anchors collaborations with UN agencies, events and the ACESS Accelerator, advancing digital transformation and AI for global health.s",
      countryCode: "CHE",
    },
  ];

  return (
    <>
      <Box id="aboutGlobalReach">
        <Box sx={{ position: "relative" }} className="globalReachSection">
          {/* Map Background */}
          <Box
            className={mapBlurred ? "map-blurred" : ""}
            sx={{
              position: "sticky",
              top: 0,
              width: "100%",
              height: "100vh",
              zIndex: 0,
            }}
          >
            <Typography
              variant="h4"
              fontWeight="bold"
              letterSpacing={2}
              gutterBottom
              className="mainHeading"
            >
              GLOBAL REACH
            </Typography>
            {/* Description */}
            <Typography
              variant="h6"
              className={`mapTagLine ${mapBlurred ? "mapTagLine-hidden" : ""}`}
              sx={{
                textAlign: { xs: "center", md: "left" },
                transition: "opacity 750ms ease-in-out",
                opacity: mapBlurred ? 0 : 1,
              }}
            >
              Projects <br />
              across{" "}
              <Box component="span" sx={{ fontWeight: 700 }}>
                50+
              </Box>{" "}
              <br />
              Countries{" "}
            </Typography>
            <div className="worldMap"></div>


            {/* Interactive Map */}
            <InteractiveMap currentCountry={currentCountry} />

            
          </Box>

          {/* Scroll Overlay */}
          <ScrollStack
            className="country-scroll"
            useWindowScroll
            onItemActive={(index) => {
              setMapBlurred(index !== null);
              setCurrentCountry(
                index !== null ? countryData[index].countryCode : null
              );
            }}
          >
            {countryData.map((data, index) => (
              <ScrollStackItem key={index}>
                <h3 className="scroll-cardcountryName">{data.heading}</h3>
                <p className="scroll-cardcountryBody">{data.body}</p>
              </ScrollStackItem>
            ))}
          </ScrollStack>
        </Box>

        <Box className="mobileGlobalReachSection">
          <video
            src={GlobalReachVideo}
            // controls
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            className="rounded-2xl shadow-lg w-100"
          />
        </Box>
      </Box>
    </>
  );
};

export default GlobalReach;
